/**
 * 会话列表。
 * - 点行：打开会话
 * - 点「⋯」（仅单聊有 userID）：打开好友扩展抽屉（由父组件渲染）
 */
import { Avatar, Badge, Button, Flex, List, Typography } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import type { ImConversation } from "../types";

type Props = {
  items: ImConversation[];
  activeId: string;
  onSelect: (id: string) => void;
  /**
   * 点「更多」：只对单聊触发。
   * 父组件据此打开 FriendActionsDrawer。
   */
  onMoreFriend?: (c: ImConversation) => void;
};

function initialOf(name: string): string {
  const t = (name || "").trim();
  return t ? t.slice(0, 1) : "?";
}

export function ConversationList({
  items,
  activeId,
  onSelect,
  onMoreFriend,
}: Props) {
  return (
    <List
      style={{ flex: 1, overflow: "auto", minHeight: 0 }}
      locale={{ emptyText: "还没有会话" }}
      dataSource={items}
      renderItem={(c) => {
        const active = c.conversationID === activeId;
        // 有 userID → 单聊，才显示好友扩展
        const isDm = Boolean(c.userID);

        return (
          <List.Item
            style={{
              cursor: "pointer",
              border: "none",
              borderRadius: 16,
              padding: "10px 12px",
              background: active ? "rgba(30, 41, 59, 0.06)" : "transparent",
            }}
            onClick={() => onSelect(c.conversationID)}
          >
            <Flex align="center" gap={12} style={{ width: "100%", minWidth: 0 }}>
              <Avatar
                size={42}
                src={c.faceURL || undefined}
                style={{ background: "#1e293b", flex: "none" }}
              >
                {initialOf(c.showName)}
              </Avatar>
              <Flex vertical style={{ minWidth: 0, flex: 1 }}>
                <Typography.Text strong ellipsis>
                  {c.showName || "未命名"}
                </Typography.Text>
                <Typography.Text type="secondary" ellipsis>
                  {c.latestMsgPreview || " "}
                </Typography.Text>
              </Flex>
              {c.unreadCount > 0 ? (
                <Badge count={c.unreadCount} color="#c5a572" />
              ) : null}

              {/* 扩展：必须 stopPropagation，否则会连带打开会话 */}
              {isDm && onMoreFriend ? (
                <Button
                  type="text"
                  size="small"
                  icon={<MoreOutlined />}
                  onClick={(e) => {
                    e.stopPropagation();
                    onMoreFriend(c);
                  }}
                />
              ) : null}
            </Flex>
          </List.Item>
        );
      }}
    />
  );
}